const excludedFilterProperties = ["updatedAt", "createdAt", "className"];

const getFilterPropertyNames = function (obj) {
  let props = [];

  do {
    const currentObj = obj;
    Object.getOwnPropertyNames(currentObj).forEach(function (prop) {
      if (!props.some((p) => p.name === prop)) {
        props.push({ name: prop, type: typeof currentObj[prop] });
      }
    });
  } while ((obj = Object.getPrototypeOf(obj)));

  return props.filter(
    (prop) =>
      !prop.name.startsWith("_") &&
      !excludedFilterProperties.includes(prop.name) &&
      (prop.type === "object" || prop.type === "string" || prop.type === "number")
  );
};

/**
 * recursively search through an object and include object if any of it's filterable properties contain text
 * @param item
 * @param text
 * @returns {*}
 */
const recursiveSearch = (item, text, _memory) => {
  let props = getFilterPropertyNames(item);
  let memory = _memory || [];
  const lowerText = text.toLowerCase();
  for (let { name } of props) {
    const value = item[name];
    if (typeof value === "object" && !memory.includes(value) && memory.push(value) && recursiveSearch(value, lowerText, memory)) {
      return item;
    } else if (typeof value === "string" && value.toLowerCase().includes(lowerText)) {
      return item;
    } else if (value && value.toString().toLowerCase() === lowerText) {
      return item;
    }
  }
};

/**
 * get a value from an object by a . delimited filedName
 * @param fieldName
 * @param record
 * @returns {string}
 */
const getValue = (fieldName, record) => {
  const path = fieldName.split(".");
  let key;
  let value = record;

  for (let i = 0; i < path.length; i++) {
    key = path[i];

    if (value[key]) {
      value = value[key];
    } else {
      value = "";
    }
  }

  return value;
};

const isAlphanumeric = (input) => {
  return /^[a-zA-Z0-9]+$/.test(input);
};

const isAlphanumericAndSpace = (input) => {
  return /^[a-zA-Z0-9 ]+$/.test(input);
};

const isEthereumAddress = (address) => {
  return /^0x[a-fA-F0-9]{40}$/.test(address);
};



const awaitTimeout = (delay, reason) =>
  new Promise((resolve, reject) =>
    setTimeout(() => {
      reason === undefined ? resolve() : reject(reason);
    }, delay)
  );

const getErrorMessage = (error) => {
  if (typeof error === "string") return error;
  if (error?.reason) return error.reason;
  if (error?.message) return error.message;
  if (error?.toString) return error.toString();
  return "An unknown error occurred";
};

export {
  getValue,
  recursiveSearch,
  isAlphanumeric,
  isAlphanumericAndSpace,
  isEthereumAddress,
  awaitTimeout,
  getErrorMessage,
};
